const SCROLL_OFFSET = 20;

function scrollDown() {
    const nextScrollTop = document.documentElement.scrollTop + SCROLL_OFFSET;
    document.documentElement.scrollTo(0, nextScrollTop);
}

function scrollUp() {
    const nextScrollTop = document.documentElement.scrollTop - SCROLL_OFFSET;
    if (nextScrollTop >= 0) {
        window.scrollTo(0, nextScrollTop);
    }
}

export default class SmoothScrollPlugin {
    /**
     * @type {{isDragging: boolean, lastMouseClientY: undefined | number}}
     */
    data = {
        isDragging: false,
        lastMouseClientY: undefined,
    };

    constructor() {
        this.addEventListeners();
    }

  onDragStart = () => {
      this.data = {
          isDragging: true,
          lastMouseClientY: undefined,
      };
      this.smoothScroll();
  };

  onDragEnd = () => {
      this.data = {
          isDragging: false,
          lastMouseClientY: undefined,
      };
  };

  addEventListeners = () => {
      document.addEventListener('touchmove', (e) => {
          this.data.lastMouseClientY = e.changedTouches[0].clientY;
      });
  };

  smoothScroll = () => {
      const { isDragging, lastMouseClientY } = this.data;
      if (isDragging) {
          if (lastMouseClientY !== undefined) {
              if (lastMouseClientY && lastMouseClientY > window.innerHeight - 200) {
                  scrollDown();
              } else if (lastMouseClientY && lastMouseClientY < 200) {
                  scrollUp();
              }
          }
          setTimeout(this.smoothScroll, 50);
      }
  };
}
